import script from "./AdminDashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardPage.vue?vue&type=style&index=0&id=7ec0afe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec0afe6"]])

export default __exports__